import { Device } from 'types';
import { logger } from '@nykaa/nes-logger';
import {
  isDeviceAndroid,
  isDeviceNotWeb,
} from '@nykaa/nes-data-layer/utils/device';
import { isValidArrayLength, isValidString } from '@nykaa/nes-utils/validations';
import { webViewCallbackhandler } from '@nykaa/nes-webview-wizard';
import { webViewCallbacks } from '@nykaa/nes-webview-wizard/constant';
import {
  CATEGORY_STATUS,
  USER_PORTFOLIO,
  CATEGORY_ID,
  STEP,
} from '@nykaa/nes-beauty-portfolio-shared/constants';
import { RawCategory } from '@nykaa/nes-beauty-portfolio-shared/store/types';
import { redirectToAuth } from 'components/SignUp/helper';
import {
  NO,
  PORTFOLIO_PAGE_VISIT,
  YES,
  ENTRY_POINT,
  GOOGLE_AUTH,
  AUTH_URL,
} from './constants';
import { localStorageService } from 'service/storage';

interface TrackingProps {
  categories: RawCategory[];
  completionPercentage: number;
  device: Device;
}

interface BPLandingProps {
  queryParams: string;
}

export const handleBPLogin = (device: Device = Device.WEB) => {
  const { href: redirectUrl } = window.location;
  if (isDeviceNotWeb(device)) {
    const appParams = {
      device,
      callbackFunctionName: webViewCallbacks.doLogin,
      callbackParams: isDeviceAndroid(device)
        ? redirectUrl
        : { redirectionURL: redirectUrl },
    };
    webViewCallbackhandler(appParams);
    return;
  } else {
    redirectToAuth();
  }
};

export const cleverTapAndGamoogaTracking = ({
  categories,
  completionPercentage,
  device,
}: TrackingProps) => {
  if (isValidArrayLength(categories)) {
    const actionName = PORTFOLIO_PAGE_VISIT;
    const categoryFilledStatus = categories.map((category: RawCategory) => ({
      [category.name]: category.status === CATEGORY_STATUS.complete ? YES : NO,
    }));

    const categoryStatusObj = categoryFilledStatus.reduce((obj, item) => {
      const key = Object.keys(item)[0];
      obj[key] = item[key];
      return obj;
    }, {});

    const finalPayload = JSON.stringify({
      ...categoryStatusObj,
      completionPercentage,
    });

    if (isDeviceNotWeb(device)) {
      const commonAppParams = {
        device: device,
      };
      const callBackFunctions = [
        webViewCallbacks.sendCleverTapTracking,
        webViewCallbacks.sendGamoogaTracking,
      ];
      const callbackParams = isDeviceAndroid(device)
        ? [actionName, finalPayload]
        : { actionName, params: finalPayload };

      callBackFunctions.forEach((callbackFunction) => {
        const appParams = {
          ...commonAppParams,
          callbackFunctionName: callbackFunction,
          callbackParams,
        };
        webViewCallbackhandler(appParams);
      });
    }
  }
};

export const setSourceUrlToStorage = () => {
  try {
    const { referrer = '' } = document;
    const excludeStrings = [USER_PORTFOLIO, GOOGLE_AUTH, AUTH_URL];
    const hasSourceUrl = !excludeStrings.some((exclude) =>
      referrer.includes(exclude)
    );
    if (!isValidString(referrer)) {
      localStorageService.setItem(ENTRY_POINT, '/');
    } else if (hasSourceUrl) {
      localStorageService.setItem(ENTRY_POINT, referrer);
    }
  } catch (error) {
    logger.error(error);
  }
};

export const getSourceFromStorage = () =>
  localStorageService.getItem(ENTRY_POINT) || '';

export const redirectToBPLandingPage = ({ queryParams }: BPLandingProps) => {
  const params = new URLSearchParams(queryParams);
  params.delete(CATEGORY_ID);
  params.delete(STEP);
  window.history.back();
};
